import(/* webpackMode: "eager" */ "/opt/build/repo/app/builder/page.tsx");
